<span>{{ frontAmount | number:format }}</span>

